import React from "react"
import { OrderShippingQliroIntegratedShipping } from "lib/types/generated/graphql-types"
import { ReactComponent as IngridLogo } from "images/providers/ingrid-logo.svg"
import CopyButton from "components/Ui/CopyButton"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import { Container, CopyWrapper, Row, Title } from "./Styled"

type Props = {
  shippingQliroIntegratedShipping: OrderShippingQliroIntegratedShipping | undefined
}

const QliroIntegratedShippingDetails = ({ shippingQliroIntegratedShipping }: Props) => {
  if (!shippingQliroIntegratedShipping?.ingrid?.deliveries) return null

  const ingridDelivery = shippingQliroIntegratedShipping?.ingrid?.deliveries.length
    ? shippingQliroIntegratedShipping?.ingrid?.deliveries[0]
    : {}

  return (
    <>
      <Title $logoMargin={"0 0.8rem 0"}>
        <IngridLogo /> details
      </Title>
      <Container>
        <Row>
          <CopyWrapper>
            <ListEntry label={"Reference"} value={shippingQliroIntegratedShipping?.ingrid?.checkoutSessionId ?? "-"} />
            <CopyButton string={shippingQliroIntegratedShipping?.ingrid?.checkoutSessionId} />
          </CopyWrapper>
          <ListEntry label={"Delivery type"} value={ingridDelivery?.deliveryType ?? "-"} />
        </Row>
        <Row>
          <CopyWrapper>
            <ListEntry label={"Transport ID"} value={ingridDelivery?.tosId ?? "-"} />
            <CopyButton string={ingridDelivery?.tosId} />
          </CopyWrapper>
          <ListEntry label={"Carrier product ID"} value={ingridDelivery?.carrierProductId ?? "-"} />
        </Row>
        <Row>
          {ingridDelivery?.deliveryAddress?.name && <ListEntry label={"Name"} value={ingridDelivery?.deliveryAddress?.name ?? "-"} />}
          {ingridDelivery?.deliveryAddress?.addressLines && <ListEntry
            label={"Address"}
            value={
              ingridDelivery?.deliveryAddress?.addressLines
                ? ingridDelivery?.deliveryAddress?.addressLines[0]
                : "-"
            }
          />}
        </Row>
        <Row>
          {ingridDelivery?.deliveryAddress?.city && <ListEntry label={"City"} value={ingridDelivery?.deliveryAddress?.city} />}
          {ingridDelivery?.deliveryAddress?.postalCode && <ListEntry
            label={"Postal code"}
            value={ingridDelivery?.deliveryAddress?.postalCode}
          />}
        </Row>
      </Container>
    </>
  )
}

export default QliroIntegratedShippingDetails
